<template>
  <Modal
    :modal-active="modelValue"
    has-header-border
    has-footer-border
    max-width="max-w-[560px]"
    @close="emit('update:modelValue', false)"
  >
    <template #header>
      <h2 class="text-xl font-bold text-textPrimary text-left">Aprovar em lote</h2>
    </template>

    <div class="flex flex-col gap-3 text-left">
      <p class="text-sm text-textPrimary" data-testid="bulk-approve-count">
        {{ countMessage }}
      </p>
      <p class="text-sm text-neutral50">
        A aprovação alimenta o pagamento e não pode ser desfeita em lote — cada registro precisaria
        ser revertido individualmente.
      </p>
      <p v-if="cappedOut > 0" class="text-sm text-alert" data-testid="bulk-approve-capped">
        O lote é limitado a {{ maxPerBatch }} registros por vez: {{ cappedOut }}
        {{ cappedOut === 1 ? 'registro elegível ficará' : 'registros elegíveis ficarão' }} para um
        próximo lote.
      </p>
    </div>

    <template #footer>
      <div class="flex flex-col sm:flex-row sm:justify-end gap-3">
        <OutlineButton
          text="Cancelar"
          width="96px"
          height="40px"
          data-testid="bulk-approve-cancel-button"
          @click="emit('update:modelValue', false)"
        />
        <FilledButton
          :text="`Aprovar ${count} ${count === 1 ? 'registro' : 'registros'}`"
          class="bg-primary30"
          width="200px"
          height="40px"
          :disabled="saving || count === 0"
          data-testid="bulk-approve-confirm-button"
          @click="emit('confirm')"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
/**
 * Apontamento 4 — a ÚNICA ação desta tela com confirmação extra, porque é a única que
 * aprova vários registros de uma vez e alimenta pagamento. A confirmação mostra a contagem
 * exata para o operador conferir antes de disparar.
 */
import { computed } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { BULK_APPROVE_MAX_CONTAINERS } from '@/constants/ds-attendance.constants'

const props = defineProps<{
  modelValue: boolean
  saving: boolean
  /** Quantos serão realmente enviados (já cortado no teto). */
  count: number
  /** Elegíveis que ficaram fora por causa do teto. */
  cappedOut?: number
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: []
}>()

const maxPerBatch = BULK_APPROVE_MAX_CONTAINERS

const countMessage = computed(() =>
  props.count === 1
    ? '1 registro 100% conciliado será aprovado.'
    : `${props.count} registros 100% conciliados serão aprovados.`
)

const cappedOut = computed(() => props.cappedOut ?? 0)
</script>
